package devxertech.com.pages.portfolio.varcity

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.ZoneArrow
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.portfolio.zone.CommonAppView
import devxertech.com.pages.portfolio.zone.CommonWebView
import devxertech.com.pages.portfolio.zone.CommonZoneAbout
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/varcity")
@Composable
fun VarcityPage() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            image = Res.Image.varcity_header,
            breakpoint = breakpoint,
            headingText = "Varcity",
            descriptionText = "Varcity is a trading simulator with real-time market data that helps traders at all levels.",
            startProject = false, careerHeight = true, careerFontSize = true, heightModification = true, commonPortfolioChanges = true
        )
        ZoneArrow("Varcity")
        CommonZoneAbout(image = Res.Image.varcity_logo, title = "Varcity",
            description = "Varcity is a trading simulator with real-time market data that helps traders at all levels develop great skills through forward testing, " +
                    "quantitative trading metrics and our Varcity Trading Index™ (VTI).")
        CommonAppView(image = Res.Image.varcity_png, breakpoint)
        CommonWebView(image = Res.Image.varcity_webview, breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)
    }
}